import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noValueTextExperiment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment',
		defaultMessage: 'Add estimate',
		description: 'Message when the field has no value',
	},
});
export default messages;
